import React, { useState, useCallback } from "react";
import axios from "axios";
import Config from "../Config/Config";
import FormData from "form-data";
import { AnimatePresence, motion } from "framer-motion";
import Spinner from "react-bootstrap/Spinner";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";

import ri1 from "../images/ri1.svg";
import ri2 from "../images/ri2.svg";
import ri3 from "../images/ri3.svg";
import AlertPopupMessage from "../ErrorPopus/AlertPopus";
import WelcomeModal from "./WelcomePopus";
import toast from "react-hot-toast";

const dropdownVariants = {
  hidden: { opacity: 0, y: -10 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.2 } },
  exit: { opacity: 0, y: -10, transition: { duration: 0.2 } },
};

const My_profile = () => {
  const getLocalStorageData = JSON.parse(localStorage.getItem("AccessLogin")) || {};

  // ----- User Profile States -----
  const [file, setFile] = useState(getLocalStorageData.profile_image);
  const [full_name, setfullName] = useState(getLocalStorageData.full_name);
  const [mobile_no, setMobileNUmber] = useState(getLocalStorageData.mobile_no);
  const [email_id, setEmailId] = useState(getLocalStorageData.email_id);
  const [gender, setGender] = useState(getLocalStorageData.gender);
  const [pincode, setPincode] = useState(getLocalStorageData.pincode);
  const [address, setAddress] = useState(getLocalStorageData.customer_full_address);
  const [Company_name, setCompanyName] = useState(getLocalStorageData.company_name);
  const [Company_pan_number, setCompany_pan_number] = useState(getLocalStorageData.company_pan_number);
  const [GSTIN, setGSTIN] = useState(getLocalStorageData.gstin_number);
  const [Company_Address, setCompanyAddress] = useState(getLocalStorageData.company_address);
  const [ReferralCode, setReferalCode] = useState("");
  const [isChecked, setIsChecked] = useState(false);

  // ----- User City Autosuggest States -----
  const [cityInputValue, setCityInputValue] = useState(getLocalStorageData.city_name || "");
  const [userStateValue, setUserStateValue] = useState(getLocalStorageData.state_name || "");
  const [cityList, setCityList] = useState([]);
  const [cityClickStatus, setCityClickStatus] = useState(false);
  const [cityHighlightedIndex, setCityHighlightedIndex] = useState(-1);
  const [isCityLoading, setIsCityLoading] = useState(false);
  const [city_id, setCityId] = useState();
  const [state_id, setStateId] = useState();

  // ----- Company City Autosuggest States -----
  const [companyCityInput, setCompanyCityInput] = useState(getLocalStorageData.company_city || "");
  const [companyStateValue, setCompanyStateValue] = useState(getLocalStorageData.company_state || "");
  const [companyCityList, setCompanyCityList] = useState([]);
  const [companyClickStatus, setCompanyClickStatus] = useState(false);
  const [companyHighlightedIndex, setCompanyHighlightedIndex] = useState(-1);
  const [isCompanyLoading, setIsCompanyLoading] = useState(false);

  // ----- File Upload Handler -----
  const handleChange = useCallback(
    (e) => {
      const fileObj = e.target.files[0];
      if (!fileObj) return;

      if (!["image/jpeg", "image/png", "image/jpg", "image/gif"].includes(fileObj.type)) {
        toast.error("Choose only PNG, JPG, JPEG format")
        return;
      }

      const FileData = new FormData();
      FileData.append("file", fileObj);
      FileData.append("_id", getLocalStorageData._id);

      axios
        .post(`${Config.API_URL}/api/customer/upload_profile_image`, FileData, {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `${Config.API_ACCESS_TOKEN}`,
          },
        })
        .then(({ data }) => {
          if (data.status) {
            setFile(data.data);
            toast.success("Profile image uploaded successfully");
          } else {
            toast.error(data.message);
          }
        })
        .catch((err) => toast.error(  err.message || "Profile Update Failed") );
    },
    [getLocalStorageData._id]
  );

  // ----- General City API Call -----
  const fetchCityList = (keyword, setListCallback, setLoadingCallback) => {
    if (!keyword) {
      setListCallback([]);
      return;
    }
    setLoadingCallback(true);
    const payload = {
      keyword,
      page_no: "1",
      records_per_page: "10",
      trip_type: "all",
    };
    axios
      .post(`${Config.API_URL}/api/customer/citylist`, JSON.parse(JSON.stringify(payload)), {
        headers: {
          Authorization: `${Config.API_ACCESS_TOKEN}`,
        },
      })
      .then(({ data }) => {
        setListCallback(data.status ? data.data : []);
      })
      .catch(() => {
        setListCallback([]);
      })
      .finally(() => setLoadingCallback(false));
  };

  // ----- User City Handlers -----
  const handleUserCityInput = useCallback(
    (e) => {
      const value = e.target.value;
      setCityInputValue(value);
      setCityClickStatus(true);
      fetchCityList(value, setCityList, setIsCityLoading);
    },
    []
  );

  const handleUserCityKeyDown = (e) => {
    if (!cityList.length) return;
    if (e.key === "ArrowDown") {
      setCityHighlightedIndex((prev) => (prev + 1) % cityList.length);
    } else if (e.key === "ArrowUp") {
      setCityHighlightedIndex((prev) => (prev - 1 + cityList.length) % cityList.length);
    } else if (e.key === "Enter" && cityHighlightedIndex >= 0) {
      selectUserCity(cityList[cityHighlightedIndex]);
    }
  };

  const selectUserCity = (item) => {
    setCityInputValue(`${item.city_name}, ${item.state_name}`);
    setCityId(item._id);
    setStateId(item.state_id);
    setUserStateValue(item.state_name);
    setCityClickStatus(false);
  };

  // ----- Company City Handlers -----
  const handleCompanyCityInputChange = useCallback(
    (e) => {
      const value = e.target.value;
      setCompanyCityInput(value);
      setCompanyClickStatus(true);
      fetchCityList(value, setCompanyCityList, setIsCompanyLoading);
    },
    []
  );

  const handleCompanyCityKeyDown = (e) => {
    if (!companyCityList.length) return;
    if (e.key === "ArrowDown") {
      setCompanyHighlightedIndex((prev) => (prev + 1) % companyCityList.length);
    } else if (e.key === "ArrowUp") {
      setCompanyHighlightedIndex((prev) => (prev - 1 + companyCityList.length) % companyCityList.length);
    } else if (e.key === "Enter" && companyHighlightedIndex >= 0) {
      selectCompanyCity(companyCityList[companyHighlightedIndex]);
    }
  };

  const selectCompanyCity = (item) => {
    setCompanyCityInput(`${item.city_name}, ${item.state_name}`);
    setCompanyStateValue(item.state_name);
    setCompanyClickStatus(false);
  };

  // ----- Form Submission -----
  const HandleSubmitToUpdateUsers = (e) => {
    e.preventDefault();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email_id)) return toast.error("Please enter a valid email");
    if (mobile_no.length !== 10) return toast.error("Please enter a valid mobile number");
    if (cityInputValue.length < 2) return toast.error("Please enter a valid city name");
    if (!["Male", "Female", "Others"].includes(gender)) return toast.error("Please select a valid gender");

    const payload = {
      _id: getLocalStorageData._id,
      city_id,
      state_id,
      file,
      full_name,
      mobile_no,
      email_id,
      address,
      gender,
      city_name: cityInputValue,
      Company_name,
      Company_Address,
      GSTIN,
      Company_pan_number,
      pincode,
      company_city: companyCityInput,
      company_state: companyStateValue,
      referral_by: ReferralCode,
    };

    axios
      .post(`${Config.API_URL}/api/customer/updateprofile`, JSON.parse(JSON.stringify(payload)), {
        headers: { Authorization: `${Config.API_ACCESS_TOKEN}` },
      })
      .then(({ data }) => {
        if (data.status) {
          localStorage.setItem("AccessLogin", JSON.stringify(data.data));
          toast.success(data.message);
        } else {
          toast.error(data.message);
        }
      })
      .catch((err) => toast.error( err?.message || "Something went wrong"));
  };

  return (
    <>
      <AlertPopupMessage />
      <WelcomeModal />
      <div className="wd_dashcontent w-75">
        <div className="container myprofilepage py-5">
          <div className="row">
            <h3>My Profile</h3>
          </div>
          <div className="row profile_form">
            <div className="col-sm-2">
              <div className="uplodpic">
                <div className="imgprw">
                  <img src={!file ? getLocalStorageData.profile_image : file} alt="Profile" />
                </div>
                <input type="file" onChange={handleChange} className="upldpic" required />
                <label>Upload Profile Pic</label>
              </div>
            </div>
            <div className="col-sm-10">
              <Form onSubmit={HandleSubmitToUpdateUsers}>
                <Row>
                  <Col xs={6}>
                    <Form.Group className="mb-3 position-relative" controlId="fullName">
                      <Form.Label>Full Name</Form.Label>
                      <img src={ri1} alt="icon" />
                      <Form.Control
                        type="text"
                        placeholder="Enter your name"
                        value={full_name}
                        onChange={(e) => setfullName(e.target.value)}
                      />
                    </Form.Group>
                  </Col>

                  <Col xs={6}>
                    <Form.Group className="mb-3 position-relative" controlId="emailId">
                      <Form.Label>Email ID</Form.Label>
                      <img src={ri2} alt="icon" />
                      <Form.Control
                        type="email"
                        placeholder="Enter your email ID"
                        value={email_id}
                        onChange={(e) => setEmailId(e.target.value)}
                      />
                    </Form.Group>
                  </Col>

                  <Col xs={6}>
                    <Form.Group className="mb-3 position-relative" controlId="mobileNumber">
                      <Form.Label>Mobile Number</Form.Label>
                      <img src={ri3} alt="icon" />
                      <Form.Control
                        type="text"
                        placeholder="Enter your mobile number"
                        maxLength={10}
                        value={mobile_no}
                        onChange={(e) => setMobileNUmber(e.target.value)}
                      />
                    </Form.Group>
                  </Col>

                  {/* ----- User City Autosuggest ----- */}
                  <Col xs={6}>
                    <Form.Group className="mb-3 position-relative" controlId="userCity">
                      <Form.Label>City</Form.Label>
                      <Form.Control
                        type="text"
                        placeholder="Enter your city"
                        value={cityInputValue}
                        onChange={handleUserCityInput}
                        onFocus={() => {
                          setCityClickStatus(true);
                          fetchCityList(cityInputValue, setCityList, setIsCityLoading);
                        }}
                        onBlur={() => setTimeout(() => setCityClickStatus(false), 400)}
                        onKeyDown={handleUserCityKeyDown}
                      />
                      <AnimatePresence>
                        {cityClickStatus && (
                          <motion.div
                            variants={dropdownVariants}
                            initial="hidden"
                            animate="visible"
                            exit="exit"
                            className="position-absolute p-2 w-100 custom-scrollbar"
                            style={{
                              maxHeight: "300px",
                              overflowY: "auto",
                              backgroundColor: "white",
                              border: "1px solid #ccc",
                              borderRadius: "4px",
                              zIndex: 999999,
                            }}
                          >
                            {isCityLoading ? (
                              <div className="d-flex justify-content-center align-items-center p-3">
                                <Spinner animation="border" size="sm" />
                              </div>
                            ) : cityList.length > 0 ? (
                              cityList.map((value, index) => (
                                <div
                                  key={value._id}
                                  onMouseDown={() => selectUserCity(value)}
                                  style={{ cursor: "pointer" }}
                                  className={`p-2 drpdwnspc ${
                                    index === cityHighlightedIndex ? "bg-primary text-white" : "hover:bg-light"
                                  }`}
                                >
                                  {value.city_name}, {value.state_name}
                                </div>
                              ))
                            ) : (
                              <div className="p-3 text-muted">No results found</div>
                            )}
                          </motion.div>
                        )}
                      </AnimatePresence>
                    </Form.Group>
                  </Col>

                  <Col xs={6}>
                    <Form.Group className="mb-3" controlId="userState">
                      <Form.Label>State</Form.Label>
                      <Form.Control type="text" disabled placeholder="State will auto-fill" value={userStateValue} />
                    </Form.Group>
                  </Col>

                  <Col xs={6}>
                    <Form.Group className="mb-3" controlId="gender">
                      <Form.Label>Gender</Form.Label>
                      <Form.Select
                        aria-label="Default select example"
                        value={gender}
                        onChange={(e) => setGender(e.target.value)}
                      >
                        <option>Select Gender</option>
                        <option value="Male">Male</option>
                        <option value="Female">Female</option>
                        <option value="Others">Others</option>
                      </Form.Select>
                    </Form.Group>
                  </Col>

                  <Col xs={6}>
                    <Form.Group className="mb-3" controlId="pincode">
                      <Form.Label>Pincode</Form.Label>
                      <Form.Control
                        type="number"
                        placeholder="Enter pincode"
                        value={pincode}
                        onChange={(e) => {
                          const inputPincode = e.target.value;
                          if (inputPincode.length <= 6) {
                            setPincode(inputPincode);
                          }
                        }}
                      />
                    </Form.Group>
                  </Col>

                  {getLocalStorageData.referral_by === "" && (
                    <Col xs={6}>
                      <Form.Group className="mb-3" controlId="referralCode">
                        <Form.Label>Referral Code</Form.Label>
                        <Form.Control
                          type="text"
                          placeholder="Enter Referral code"
                          value={ReferralCode}
                          onChange={(e) => setReferalCode(e.target.value.toUpperCase())}
                        />
                      </Form.Group>
                    </Col>
                  )}

                  <Col xs={6}>
                    <Form.Group className="mb-3" controlId="address">
                      <Form.Label>Address</Form.Label>
                      <Form.Control
                        as="textarea"
                        placeholder="Enter complete address"
                        value={address}
                        rows={5}
                        onChange={(e) => setAddress(e.target.value)}
                      />
                    </Form.Group>
                  </Col>
                </Row>

                <hr />

                <Col xs={6}>
                  <Form.Group className="mb-3" controlId="isCompanyRegistered">
                    <Form.Check
                      type="checkbox"
                      label="Is Company Registered"
                      checked={isChecked}
                      onChange={(e) => setIsChecked(e.target.checked)}
                    />
                  </Form.Group>
                </Col>

                {isChecked && (
                  <Row>
                    <Col xs={6}>
                      <Form.Group className="mb-3" controlId="companyName">
                        <Form.Label>Company Name</Form.Label>
                        <Form.Control
                          type="text"
                          placeholder="Enter name"
                          value={Company_name}
                          onChange={(e) => setCompanyName(e.target.value)}
                        />
                      </Form.Group>
                    </Col>

                    <Col xs={6}>
                      <Form.Group className="mb-3" controlId="companyPan">
                        <Form.Label>Company Pan Number</Form.Label>
                        <Form.Control
                          type="text"
                          placeholder="Enter PAN number"
                          maxLength={10}
                          value={Company_pan_number}
                          onChange={(e) => setCompany_pan_number(e.target.value.toUpperCase())}
                        />
                      </Form.Group>
                    </Col>

                    <Col xs={6}>
                      <Form.Group className="mb-3" controlId="companyGSTIN">
                        <Form.Label>GSTIN</Form.Label>
                        <Form.Control
                          type="text"
                          placeholder="Enter GST number"
                          maxLength={10}
                          value={GSTIN}
                          onChange={(e) => setGSTIN(e.target.value.toUpperCase())}
                        />
                      </Form.Group>
                    </Col>

                    {/* ----- Company City Autosuggest ----- */}
                    <Col xs={6}>
                      <Form.Group className="mb-3 position-relative" controlId="companyCity">
                        <Form.Label>Company City</Form.Label>
                        <Form.Control
                          type="text"
                          placeholder="Enter company city"
                          value={companyCityInput}
                          onChange={handleCompanyCityInputChange}
                          onFocus={() => {
                            setCompanyClickStatus(true);
                            fetchCityList(companyCityInput, setCompanyCityList, setIsCompanyLoading);
                          }}
                          onBlur={() => setTimeout(() => setCompanyClickStatus(false), 400)}
                          onKeyDown={handleCompanyCityKeyDown}
                        />
                        <AnimatePresence>
                          {companyClickStatus && (
                            <motion.div
                              variants={dropdownVariants}
                              initial="hidden"
                              animate="visible"
                              exit="exit"
                              className="position-absolute p-2 w-100 custom-scrollbar"
                              style={{
                                maxHeight: "300px",
                                overflowY: "auto",
                                backgroundColor: "white",
                                border: "1px solid #ccc",
                                borderRadius: "4px",
                                zIndex: 999999,
                              }}
                            >
                              {isCompanyLoading ? (
                                <div className="d-flex justify-content-center align-items-center p-3">
                                  <Spinner animation="border" size="sm" />
                                </div>
                              ) : companyCityList.length > 0 ? (
                                companyCityList.map((value, index) => (
                                  <div
                                    key={value._id}
                                    onMouseDown={() => selectCompanyCity(value)}
                                    style={{ cursor: "pointer" }}
                                    className={`p-2 drpdwnspc ${
                                      index === companyHighlightedIndex ? "bg-primary text-white" : "hover:bg-light"
                                    }`}
                                  >
                                    {value.city_name}, {value.state_name}
                                  </div>
                                ))
                              ) : (
                                <div className="p-3 text-muted">No results found</div>
                              )}
                            </motion.div>
                          )}
                        </AnimatePresence>
                      </Form.Group>
                    </Col>

                    <Col xs={6}>
                      <Form.Group className="mb-3" controlId="companyState">
                        <Form.Label>Company State</Form.Label>
                        <Form.Control type="text" disabled placeholder="State will auto-fill" value={companyStateValue} />
                      </Form.Group>
                    </Col>

                    <Col xs={6}>
                      <Form.Group className="mb-3" controlId="companyAddress">
                        <Form.Label>Company Address</Form.Label>
                        <Form.Control
                          as="textarea"
                          placeholder="Enter complete address"
                          value={Company_Address}
                          rows={5}
                          onChange={(e) => setCompanyAddress(e.target.value)}
                        />
                      </Form.Group>
                    </Col>
                  </Row>
                )}

                <Button className="sitebtn" type="submit">
                  Save
                </Button>
              </Form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default My_profile;
